import { Component, OnInit } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { Populations } from 'src/app/shared/utilities/populations';

@Component({
  selector: 'fgb-earn-page',
  templateUrl: './earn-page.component.html',
  styleUrls: ['./earn-page.component.scss'],
})
export class EarnPageComponent implements OnInit {
  deviceType: string;
  population = Populations;

  constructor(private deviceDetector: DeviceDetectorService) { }

  ngOnInit() {
    this.deviceType = this.deviceDetector.os.toUpperCase();
  }
}
